let parameters = {
    dashboards: {
        label: 'Tab Dashboards',
        class: 'xs12 sm12 d-flex',
        type: 'multi-select',
        source: 'charts',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: false,
        value: []
    },
    color: {
        label: 'Color ',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [
          {id: 'red', name: 'Red'},
          {id: 'pink', name: 'Pink'},
          {id: 'purple', name: 'Purple'},
          {id: 'deep-purple', name: 'Deep Purple'},
          {id: 'indigo', name: 'Indigo'},
          {id: 'blue', name: 'Blue'},
          {id: 'light-blue', name: 'Light Blue'},
          {id: 'cyan', name: 'Cyan'},
          {id: 'teal', name: 'Teal'},
          {id: 'green', name: 'Green'},
          {id: 'light-green', name: 'Light Green'},
          {id: 'lime', name: 'Lime'},
          {id: 'yellow', name: 'Yellow'},
          {id: 'amber', name: 'Amber'},
          {id: 'orange', name: 'Orange'},
          {id: 'deep-orange', name: 'Deep Orange'},
          {id: 'brown', name: 'Brown'},
          {id: 'blue-grey', name: 'Blue Grey'},
          {id: 'black', name: 'Black'},
          {id: 'white', name: 'White'},
          {id: 'grey', name: 'Grey'},
          {id: 'transparent', name: 'Transparent'}
        ],
        wait: false,
        value: 'white'
    },
    tabAlign: {
      groupId: 'design',
      label: 'Tab Alignment',
      class: 'xs12 sm12 d-flex',
      type: 'select',
      itemText: 'name',
      itemValue: 'id',
      item: {},
      items: [
        {id: 'left', name: 'Left'},
        {id: 'centered', name: 'Centered'},
        {id: 'right', name: 'Right'}
      ],
      wait: false,
      value: 'centered'
    },
    sliderColor: {
      groupId: 'design',
      label: 'Slider Color',
      class: 'xs4',
      type: 'colorPicker',
      multiple: false,
      value: '#8BC34A',
      wait: false
    },
    fontColor: {
      groupId: 'design',
      label: 'Font Color',
      class: 'xs4',
      type: 'colorPicker',
      multiple: false,
      value: '#000000',
      wait: false
    },
    tabBgColor: {
      groupId: 'design',
      label: 'Background Color',
      class: 'xs4',
      type: 'colorPicker',
      multiple: false,
      value: '#FFFFFF',
      wait: false
    },
    sliderColor2: {
        label: 'Slider Color ',
        class: 'xs12 sm12 d-flex',
        type: 'select22',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [
          {id: 'red', name: 'Red'},
          {id: 'pink', name: 'Pink'},
          {id: 'purple', name: 'Purple'},
          {id: 'deep-purple', name: 'Deep Purple'},
          {id: 'indigo', name: 'Indigo'},
          {id: 'blue', name: 'Blue'},
          {id: 'light-blue', name: 'Light Blue'},
          {id: 'cyan', name: 'Cyan'},
          {id: 'teal', name: 'Teal'},
          {id: 'green', name: 'Green'},
          {id: 'light-green', name: 'Light Green'},
          {id: 'lime', name: 'Lime'},
          {id: 'yellow', name: 'Yellow'},
          {id: 'amber', name: 'Amber'},
          {id: 'orange', name: 'Orange'},
          {id: 'deep-orange', name: 'Deep Orange'},
          {id: 'brown', name: 'Brown'},
          {id: 'blue-grey', name: 'Blue Grey'},
          {id: 'black', name: 'Black'},
          {id: 'white', name: 'White'},
          {id: 'grey', name: 'Grey'},
          {id: 'transparent', name: 'Transparent'}
        ],
        wait: false,
        value: 'light-green'
    }
};


export default parameters;
